export interface IBaseSliderModel {
  key: string;
  type: string;
  props: RangeSliderProps;
}

export interface RangeSliderProps {
  min?: number;
  max?: number;
  from?: number;
  to?: number;
  step?: number;
  values?: any[];
  formName?: string;
  prefix?: string;
  max_postfix?: string;
  postfix?: string;
  label?: string;
}

/**
 * the value of "type" needs to match the one declared in the app module.
 */
export const rangeSliderNoList: IBaseSliderModel = {
  key: 'rangeSliderNoList',
  type: 'custom-slider',
  props: {
    from: null,
    to: null,
  },
};

export const rangeSliderWithList: IBaseSliderModel = {
  key: 'rangeSliderWithList',
  type: 'custom-slider',
  props: {
    values: [
      0, 50000, 100000, 150000, 200000, 250000, 300000, 350000, 400000, 450000,
      500000, 550000, 600000, 650000, 700000, 750000, 800000, 850000, 900000,
      950000, 1000000,
    ],
  },
};
